import { compose } from "redux";
import classNames from "classnames";
import React, { PureComponent } from "react";
import { Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import { formatDate } from "utils/format.util";
import CalendarWeekNumber from "app/components/CalendarYear/CalendarWeekNumber";
import WorkScheduleReportItem from "features/planner/report/workSchedule/components/WorkScheduleReportItem";

class WorkScheduleMonthReportHeaderDay extends PureComponent {
  render() {
    const { date, classes, title } = this.props;

    return (
      <WorkScheduleReportItem
        title={title}
        classes={{
          root: classNames(classes.root, {
            [classes.isToday]: date.isSame(undefined, "day"),
          }),
        }}
      >
        <CalendarWeekNumber date={date} color="primary" />
        <Grid
          item
          container
          variant="caption"
          direction="column"
          alignItems="center"
          className={classes.dateContainer}
        >
          <Typography variant="caption" className={classes.dateDay}>
            {date.date()}
          </Typography>
          <Typography variant="caption" className={classes.dateDayName}>
            {formatDate(date, "ddd").toUpperCase()}
          </Typography>
        </Grid>
      </WorkScheduleReportItem>
    );
  }
}

const styles = theme => ({
  root: {
    height: theme.altus.mediumRow.height,
    background: theme.palette.grey[50],
    "&:hover": {
      background: theme.altus.calendar.workdayOffColor.hover,
    },
  },
  dateContainer: {
    left: "50%",
    position: "absolute",
    bottom: theme.spacing(0.5),
    transform: "translateX(-50%)",
    zIndex: theme.zIndex.calendarDay,
    color: theme.palette.text.secondary,
  },
  isToday: {
    background: theme.altus.calendar.contrastColor,
    "& $dateDay": {
      color: theme.palette.primary.contrastText,
    },
    "& $dateDayName": {
      color: theme.palette.primary.contrastText,
    },
    "& .CalendarWeekNumber": {
      color: theme.palette.primary.contrastText,
    },
  },
  dateDay: {
    fontSize: "0.75rem",
    lineHeight: "0.75rem",
    fontWeight: theme.typography.fontWeightBold,
  },
  dateDayName: {
    fontSize: "0.5rem",
  },
});

export default compose(withStyles(styles))(WorkScheduleMonthReportHeaderDay);
